const ACCESS_TOKEN_KEY = 'batipilot.accessToken'
const REFRESH_TOKEN_KEY = 'batipilot.refreshToken'
const USER_SESSION_KEY = 'batipilot.user'
const TWO_FACTOR_PENDING_KEY = 'batipilot.twoFactorPending'

const LEGACY_KEYS = [ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, USER_SESSION_KEY, TWO_FACTOR_PENDING_KEY]

export const purgeLegacyAuthStorage = () => {
  LEGACY_KEYS.forEach((key) => localStorage.removeItem(key))
}

export const getAccessToken = () => sessionStorage.getItem(ACCESS_TOKEN_KEY)

export const setAccessToken = (token) => {
  if (token) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, token)
  } else {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY)
  }
}

export const getRefreshToken = () => sessionStorage.getItem(REFRESH_TOKEN_KEY)

export const setRefreshToken = (token) => {
  if (token) {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, token)
  } else {
    sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  }
}

export const getSessionUserRaw = () => sessionStorage.getItem(USER_SESSION_KEY)

export const setSessionUserRaw = (value) => {
  if (value) {
    sessionStorage.setItem(USER_SESSION_KEY, value)
  } else {
    sessionStorage.removeItem(USER_SESSION_KEY)
  }
}

export const clearAuthStorage = () => {
  sessionStorage.removeItem(ACCESS_TOKEN_KEY)
  sessionStorage.removeItem(REFRESH_TOKEN_KEY)
  sessionStorage.removeItem(USER_SESSION_KEY)
  sessionStorage.removeItem(TWO_FACTOR_PENDING_KEY)
}

export const getTwoFactorPendingRaw = () => sessionStorage.getItem(TWO_FACTOR_PENDING_KEY)

export const setTwoFactorPendingRaw = (value) => {
  if (value) {
    sessionStorage.setItem(TWO_FACTOR_PENDING_KEY, value)
  } else {
    sessionStorage.removeItem(TWO_FACTOR_PENDING_KEY)
  }
}
